var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-grey-00 px-1 md:px-4 lg:px-6"},[(_vm.currentProduct)?_c('catalog-show',{attrs:{"create-route":"single-product-designer","product-category":_vm.productCategory,"catalog-product":_vm.currentProduct},on:{"calculation":_vm.goToCalculation}}):_vm._e(),_vm._v(" "),(_vm.loading)?_c('loader-full-page'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }